module.exports = __webpack_public_path__ + "static/media/RawsonPro-Regular.6fa12cab.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/RawsonPro/Regular/RawsonPro-Regular.eot
// module id = 373
// module chunks = 17